import { queryClient } from '../App'

export const useInvalidateQueries = () => {
  return (keysArr: string[]) => {
    keysArr.forEach((key) => {
      queryClient.invalidateQueries({
        queryKey: [key],
      })
    })
  }
}
